export default function TelegramStarsFilledIcon({ size, className }: Icon) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			className={className || "-translate-y-0.5"}
			viewBox="0 0 12 13"
			fill="none"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.70064 10.2349L3.19467 11.7702C2.93408 11.9298 2.59343 11.8479 2.43382 11.5874C2.35584 11.46 2.33261 11.3067 2.36935 11.162L2.75728 9.63519C2.89731 9.084 3.27449 8.62325 3.78716 8.37709L6.52103 7.06451C6.64848 7.00329 6.70224 6.85039 6.64103 6.72294C6.59148 6.61969 6.47939 6.56195 6.36658 6.5815L3.32341 7.10835C2.70479 7.21544 2.07042 7.0446 1.58922 6.64135L0.627859 5.8357C0.393646 5.63945 0.362893 5.29045 0.559169 5.05623C0.654634 4.94231 0.791909 4.8716 0.940083 4.86L3.87734 4.63013C4.08485 4.6139 4.26571 4.48258 4.34536 4.29028L5.47848 1.55494C5.59544 1.27262 5.91914 1.13857 6.20144 1.25552C6.337 1.31168 6.44468 1.41938 6.50088 1.55494L7.63399 4.29028C7.71368 4.48258 7.89449 4.6139 8.10203 4.63013L11.0554 4.86127C11.3601 4.88511 11.5877 5.1514 11.5638 5.45607C11.5524 5.60259 11.483 5.73861 11.3712 5.83395L9.11883 7.75421C8.96019 7.88941 8.89103 8.10221 8.93979 8.30476L9.63223 11.1814C9.70379 11.4785 9.52089 11.7773 9.22383 11.8488C9.08104 11.8832 8.93049 11.8594 8.80528 11.7827L6.27875 10.2349C6.10133 10.1263 5.87804 10.1263 5.70064 10.2349Z"
				fill="currentColor"
			/>
		</svg>
	);
}
